import React, { FC } from 'react'
import { Field, useFormikContext } from 'formik'
import { PaymentFormValues } from '@entities/payment'
import { steamSumAddGtm } from '@shared/lib/gtm/redesign'
import { MoneyInputField } from '@shared/ui/organisms'

const SteamAmountField: FC = () => {
  const { values, validateForm, handleBlur } = useFormikContext<PaymentFormValues>()

  const handleAmountFieldBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    const validationErrors = await validateForm()

    if (!validationErrors?.price && values.price) {
      steamSumAddGtm(values.price.replace(/\s/g, ''))
    }

    handleBlur(e)
  }

  return (
    <Field
      size={{ mobile: '64', desktop: '72' }}
      name="price"
      label="Отправите"
      autoComplete="off"
      maxLength={8}
      decimalLimit={2}
      onBlur={handleAmountFieldBlur}
      component={MoneyInputField}
    />
  )
}

export default SteamAmountField
